import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PopupLink from '../../../../shared-components/PopupLink/PopupLink';
import StickyFooter from '../../../../shared-components/StickyFooter/StickyFooter';
import DynamicIframe from '../../../../shared-components/DynamicIframe/DynamicIframe';
import Waypoint from 'react-waypoint';
import CancelUrl, { COMPONENT_STYLE } from '../../../components/CancelUrl/CancelUrl';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import { spinnerOpen, spinnerClose } from '../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import Button, {BUTTON_STYLE} from '../../../../shared-components/Button/Button';
import { FLOW_TYPE } from '../../../../framework/App/AppConstants';
import './TermsAndConditions.less';
import { overrideTermsStyles } from '../TermsPageActions';
import { push } from 'connected-react-router';
import { PAGE_NAME } from '../../../config/pageNames';
import { setServerData } from '../../../../framework/store/ServerData/ServerDataActions';
import { reportFCI } from '../../../../framework/store/ReportFCI/ReportFCIActions';
import PageHeaderText from '../../../../shared-components/Typography/PageHeaderText';

const LOCALE_PREFIX = 'US/pages/TermsPage/TermsAndConditions';
export const DEFAULT_IFRAME_LOAD_TIMEOUT = 25000;
// Expected default minimum length for terms content for pre ALP2
export const DEFAULT_TERMS_CONTENT_LENGTH_MIN_THRESHOLD_PRE_ALP2 = 50000;
// Expected default minimum length for terms content
export const DEFAULT_TERMS_CONTENT_LENGTH_MIN_THRESHOLD = 40000;

export const addNonceToTags = (htmlString, nonce) => htmlString.replace(
    /<script>/gi,
    `<script nonce="${nonce}">`
);

export class TermsAndConditions extends Component {
    static propTypes = {
        isMobile: PropTypes.bool,
        onIframeLoaded: PropTypes.func.isRequired,
        onIframeError: PropTypes.func.isRequired,
        onBeforeIframeLoaded: PropTypes.func.isRequired,
        onTermsUnmount: PropTypes.func.isRequired,
        iframeLoadTimeout: PropTypes.number,
        expectedTermsLengthMinThreshold: PropTypes.number,
        usTermsUri: PropTypes.string.isRequired,
        flowType: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        nonce: PropTypes.string.isRequired,
        // Passed in props
        addAriaDescribedBy: PropTypes.bool.isRequired,
        creditType: PropTypes.string,
        handleCancel: PropTypes.func.isRequired,
        onShowDoubleConsent: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            htmlTerms: undefined,
            fixToBottom: true
        };

        props.onBeforeIframeLoaded();
    }

    componentDidMount = () => {
        const { usTermsUri, onIframeError, flowType, nonce } = this.props;
        axios
            .get(usTermsUri)
            .then(response => {
                if (response.status !== 200) {
                    throw new Error(`terms, handleIframeLoad=response_not_200, responseStatus=${response.status}`);
                }
                capeLog && capeLog('TermsAndConditions-handleIframeLoad');
                const htmlTerms = addNonceToTags(response.data, nonce);
                this.setState({
                    htmlTerms,
                    fixToBottom: true
                });
            })
            .catch(error => {
                capeLog && capeLog(`TermsAndConditions-Error, ${error.message}`);
                return onIframeError(flowType);
            });
    }

    handleIframeWrite = () => {
        const { expectedTermsLengthMinThreshold, onIframeError, flowType } = this.props;
        const iframe = document.getElementById('terms-and-conditions-iframe');
        const iframeDoc = iframe.contentDocument || _.get(iframe, 'contentWindow.document');
        // There might be some issue with fetching terms content and we might not show user appropriate terms due to that.
        // Therefore we expect terms to be of certain minimum length in order for user to see the terms else we show user error page.
        const actualTermsLength = _.get(iframeDoc, 'body.innerText.length');
        if (actualTermsLength < expectedTermsLengthMinThreshold) {
            // Since the expected length of the terms is less than expected minimum length, we show error to the user.
            capeLog && capeLog(`terms, handleIframeLoad=iframeDoc_less_than_${expectedTermsLengthMinThreshold} actualTermsLength=${actualTermsLength}`);
            return onIframeError(flowType);
        }
        try {
            overrideTermsStyles();
        } catch (err) {
            capeLog && capeLog('error_overriding_term_styles=${err.message}');
        }
        try {
            iframeDoc.body.classList.add('ppcTerms-mini');
        } catch (err) {
            capeLog && capeLog(`TermsAndConditions-Error, cannot showMini, err=${err.message}`);
        }
        this.props.onIframeLoaded();
    }

    handleWaypointEnter = () => this.setState({ fixToBottom: false });

    handleWaypointLeave = () => this.setState({ fixToBottom: true });

    componentWillUnmount() {
        this.props.onTermsUnmount();
    }

    render() {
        const {
            onShowDoubleConsent,
            isMobile,
            handleCancel,
            usTermsUri,
            addAriaDescribedBy       
        } = this.props;
        const { htmlTerms, fixToBottom } = this.state;
        let termsIframe;

        if (htmlTerms) {
            termsIframe = (
                <DynamicIframe
                    scrolling="no"
                    autoHeight={true}
                    htmlString={htmlTerms}
                    extraHeight={32}
                    id="terms-and-conditions-iframe"
                    className="TermsAndConditions-iframe"
                    onHtmlStringWrite={this.handleIframeWrite}
                />
            );
        }

        capeLog && capeLog('TermsAndConditions-render');
        return (
            <div id="TermsAndConditions" className="termsPage">
                <div id="bmlTermsAndConditions">
                    <div className="bmlTermsHeader clearfix">
                        <div className="pull-left">
                            <PageHeaderText>
                                <FormattedMessage id={`${LOCALE_PREFIX}.agreement-terms-title`} />
                            </PageHeaderText>
                        </div>

                        <p className="printContent">
                            <span className={(isMobile) ? 'download_icon' : 'print_icon'} />
                            <PopupLink url={usTermsUri} name="printHtmlLink">
                                <FormattedMessage id={`${LOCALE_PREFIX}.${isMobile ? 'download' : 'print-copy'}`} />
                            </PopupLink>
                        </p>
                    </div>
                    <div
                        id="bmlTermsAndConditions"
                        className="trayInner trayInnerDefault trayTerms termsInstallments"
                    >
                        <div className="bmlTermsBody">
                            <div id="terms">
                                {termsIframe}
                            </div>
                        </div>
                        <StickyFooter fixToBottom={fixToBottom} fadedBackground={true}>
                            <p className="creditCheck">Next we&apos;ll complete a quick credit check.</p>
                            <div className="buttons body-content">
                                <Button
                                    id="termsSubmit"
                                    btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                    className="bmlAgreeToTerms"
                                    onClick={onShowDoubleConsent}
                                    data-automation-id="continue"
                                    aria-describedby={addAriaDescribedBy ? 'justToConfirm' : undefined}
                                >
                                    <FormattedMessage id={`${LOCALE_PREFIX}.agree-apply`} />
                                </Button>

                                <CancelUrl
                                    componentType={COMPONENT_STYLE.LINK_BUTTON}
                                    onClick={handleCancel}
                                />
                            </div>
                        </StickyFooter>
                        <Waypoint
                            onEnter={this.handleWaypointEnter}
                            onLeave={this.handleWaypointLeave}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => {
    const iframeLoadTimeout = _.get(state, 'serverData.featureFlags.iframeTermsLoadTimeout') ||
        DEFAULT_IFRAME_LOAD_TIMEOUT;
    const usTermsUri = _.get(state, 'serverData.featureFlags.usTermsUri');
    const expectedTermsLengthMinThreshold = _.get(state, 'serverData.featureFlags.termsContentLengthMinThreshold')
    || DEFAULT_TERMS_CONTENT_LENGTH_MIN_THRESHOLD;

    return {
        iframeLoadTimeout,
        usTermsUri,
        expectedTermsLengthMinThreshold,
        flowType: _.get(state, 'serverData.flow'),
        nonce: _.get(state, 'serverData.nonce')
    };
};

export const mapDispatchToProps = dispatch => ({
    onBeforeIframeLoaded() {
        dispatch(spinnerOpen('base.loading-terms'));
    },
    onIframeLoaded() {
        dispatch(trackTransition('pp_credit_termspage', 'iframe_loaded_pp_credit_termspage'));
        dispatch(spinnerClose());
    },
    onIframeError(flowType) {
        const errorModel = {
            errorType: 'ppCreditTermsError',
            message: 'Error loading Terms and Conditions iframe',
            service: 'mpp-terms'
        };
        if (flowType === FLOW_TYPE.DIRECT_APP) {
            errorModel.errorType = `${errorModel.errorType}${_.toUpper(FLOW_TYPE.DIRECT_APP)}`;
        }

        capeLog && capeLog(errorModel.message);

        dispatch(setServerData({ errorModel }));
        dispatch(trackTransition('pp_credit_termspage', 'iframe_error_pp_credit_termspage'));
        dispatch(push(PAGE_NAME.ERROR_PAGE));
        dispatch(reportFCI());
        dispatch(spinnerClose());
    },
    onTermsUnmount() {
        dispatch(spinnerClose());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);
